import React from 'react';
import './DashboardCharts.css';

/* === UTILS === */


/* === LINE CHART (Growth/Trends) === */
export const LineChart = ({ data, color = '#FF6B00', title }) => {
    if (!data || data.length < 2) return <div className="chart-placeholder">Not enough data</div>;

    const values = data.map(d => d.value);
    const max = Math.max(...values);
    const min = Math.min(...values);
    const range = max - min || 1;

    // Generate SVG Points
    const points = data.map((d, i) => {
        const x = (i / (data.length - 1)) * 100;
        const y = 100 - ((d.value - min) / range) * 100;
        return `${x},${y}`;
    }).join(' ');

    const fillPoints = `0,100 ${points} 100,100`;

    return (
        <div className="chart-container line-chart">
            {title && <h3 className="chart-title">{title}</h3>}
            <div className="svg-wrapper">
                <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                    <defs>
                        <linearGradient id={`grad-${color}`} x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor={color} stopOpacity="0.4" />
                            <stop offset="100%" stopColor={color} stopOpacity="0" />
                        </linearGradient>
                    </defs>
                    <polygon points={fillPoints} fill={`url(#grad-${color})`} />
                    <polyline points={points} fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke" />
                </svg>
            </div>
            <div className="chart-labels">
                <span>{data[0].label}</span>
                <span>{data[data.length - 1].label}</span>
            </div>
        </div>
    );
};

/* === BAR CHART (Comparison) === */
export const BarChart = ({ data, color = '#3b82f6', title }) => {
    if (!data || data.length === 0) return <div className="chart-placeholder">No Data</div>;
    const max = Math.max(...data.map(d => d.value)) || 1;

    return (
        <div className="chart-container bar-chart">
            {title && <h3 className="chart-title">{title}</h3>}
            <div className="bars-wrapper">
                {data.map((d, i) => (
                    <div key={i} className="bar-group" title={`${d.label}: ${d.value}`}>
                        <div
                            className="bar-fill"
                            style={{
                                height: `${(d.value / max) * 100}%`,
                                backgroundColor: d.color || color
                            }}
                        />
                        <span className="bar-label">{d.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

/* === DONUT CHART (Distribution) === */
export const DonutChart = ({ data, title }) => {
    // CSS Conic Gradient implementation
    let gradientString = '';
    let currentAngle = 0;
    const total = data.reduce((acc, curr) => acc + curr.value, 0) || 1;

    data.forEach((d, i) => {
        const angle = (d.value / total) * 360;
        const start = currentAngle;
        const end = currentAngle + angle;
        gradientString += `${d.color || '#fff'} ${start}deg ${end}deg${i < data.length - 1 ? ', ' : ''}`;
        currentAngle += angle;
    });

    return (
        <div className="chart-container donut-chart">
            {title && <h3 className="chart-title">{title}</h3>}
            <div className="donut-wrapper">
                <div className="donut-circle" style={{ background: `conic-gradient(${gradientString})` }}>
                    <div className="donut-hole">
                        <span className="donut-total">{total}</span>
                        <span className="donut-label">Total</span>
                    </div>
                </div>
                <div className="donut-legend">
                    {data.map((d, i) => (
                        <div key={i} className="legend-item">
                            <span className="legend-dot" style={{ background: d.color }}></span>
                            <span className="legend-text">{d.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
